import { t as translate } from '@/utils/i18n-helper'
import { getI18nInstance } from '@/lang'

/**
 * i18n 翻译 mixin
 * 在组件中通过 this.$tr() 使用
 */
export default {
  data() {
    return {
      $_i18nLocale: ''
    }
  },
  created() {
    // 获取已初始化的 i18n 实例
    const i18n = getI18nInstance()
    if (i18n) {
      this.$_i18nLocale = i18n.locale
    }
  },
  methods: {
    /**
     * 翻译方法
     * @param {string} key - 翻译的 key
     * @param {string} defaultValue - 默认值（当翻译缺失时使用）
     * @param {object} values - 插值参数（可选）
     * @returns {string} 翻译后的文本
     *
     * @example
     * this.$tr('global.query', '查询')
     * this.$tr('role.roleName', '角色名称', { name: 'Admin' })
     */
    $tr(key, defaultValue = '', values = {}) {
      // 访问响应式数据，触发重新渲染
      const i18n = getI18nInstance()
      if (i18n) {
        this.$_i18nLocale = i18n.locale
      }
      return translate(key, defaultValue, values)
    }
  }
}
